import { Box, Button, Typography } from "@mui/material"

export const DataSourceCard = ({
  sourceName,
  dataOwner,
  description,
  sourceURL,
}: {
  sourceName: string
  dataOwner: string
  description?: string
  sourceURL?: string
}) => {
  return (
    <Box>
      <Typography variant="body2Bold">
        {sourceName} - {dataOwner}
      </Typography>
      <Typography variant="body2">{description}</Typography>
      {sourceURL ? (
        <Button
          variant="contained"
          color="primary"
          href={sourceURL}
          target="_blank"
          size="small"
        >
          View Source
        </Button>
      ) : null}
    </Box>
  )
}
